import { render, staticRenderFns } from "./EditAid.vue?vue&type=template&id=318ec842"
import script from "./EditAid.vue?vue&type=script&lang=js"
export * from "./EditAid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports